import { cn } from "@newxsystems/shared";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetRichText } from "../../../../modules/content/components/VelvetRichText/VelvetRichText";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-16 md:gap-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid border-t border-parchment/60", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <article
              className="group relative min-h-72 overflow-hidden border-b border-parchment/25 py-8 transition-colors hover:text-thread sm:px-6 sm:first:pl-0 sm:last:pr-0 md:min-h-80 md:py-10"
              key={index}
            >
              <p className="font-velvet-display text-7xl font-black leading-[0.78] tracking-[-0.04em] text-thread md:text-[6rem]">
                {item.value}
              </p>
              <h3 className="mt-16 border-t border-parchment/20 pt-4 font-velvet-body text-xl italic text-foreground">
                {item.label}
              </h3>
              {item.description ? (
                <VelvetRichText
                  className="mt-3 max-w-[32ch] text-base text-smoke md:text-lg"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </VelvetSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
